import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createCategoryValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  description: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
